import React, { useEffect, useState } from "react";

const formatNumber = (num) => {
  var num_parts = num.toString().split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return num_parts.join(".");
};

const pad = (a, b) => {
  return (1e15 + a + "").slice(-b);
};

const CompareRow = ({ data, types,currentType, handleUpdatedData,dataSum }) => {
  const [currentData, setCurrentData] = useState(null);
  let tongSum1 = "";
  if(dataSum.reports && dataSum.reports[0].data){
    tongSum1 = dataSum.reports && dataSum.reports2 ? parseInt(dataSum.reports[0].data.totals[0].values[0]) : "";
  }
  if(dataSum.reports && dataSum.reports[0].rows){
    tongSum1 = dataSum.reports && dataSum.reports2 ? parseInt(dataSum.reports[0].rows[0].metricValues[0].value) : "";
  }
  let tongSum2 = "";
  if(dataSum.reports && dataSum.reports2 &&  dataSum.reports2[0].data){
    tongSum2 = dataSum.reports && dataSum.reports2 ? parseInt(dataSum.reports2[0].data.totals[0].values[0]) : "";
  }
  if(dataSum.reports && dataSum.reports2 &&  dataSum.reports2[0].rows){
    tongSum2 = dataSum.reports && dataSum.reports2 ? parseInt(dataSum.reports2[0].rows[0].metricValues[0].value) : "";
  }
  
  let tong1 = "";
  if(data.reports && data.reports2 && data.reports[0].data){
    tong1 = data.reports && data.reports2 ? parseInt(data.reports[0].data.totals[0].values[0]) : "";
  }
  if(data.reports && data.reports2 && data.reports[0].rows){
    tong1 = data.reports && data.reports2 ? parseInt(data.reports[0].rows[0].metricValues[0].value) : "";
  }
  const tileTong1 = tongSum1 > 0 ? parseFloat((tong1 / tongSum1 * 100)).toFixed(2) : "";

  let tong2 = "";
  if(data.reports && data.reports2 && data.reports2[0].data){
    tong2 = data.reports && data.reports2 ? parseInt(data.reports2[0].data.totals[0].values[0]) : "";
  }
  if(data.reports && data.reports2 && data.reports2[0].rows){
    tong2 = data.reports && data.reports2 ? parseInt(data.reports2[0].rows[0].metricValues[0].value) : "";
  }
  
  const tileTong2 = tongSum2 > 0 ? parseFloat((tong2 / tongSum2 * 100)).toFixed(2) : "";
  const tile = tong2 > 0 ? parseFloat((tong1 / tong2 * 100) - 100).toFixed(2) : "";
  
  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(currentData)) {
      if (currentData && handleUpdatedData) {
        handleUpdatedData(currentType);
      }

      setCurrentData(data);
    }
  }, [data]);
  return (
    <tr>
      <td>{currentType}</td>
      <td>{formatNumber(tong2)}{` (${tileTong2.replace(".",",")}%)`}</td>
      <td>{formatNumber(tong1)}{` (${tileTong1.replace(".",",")}%)`}</td>
      <td className={tile > 0 ? "text-success" : "text-danger"}>{tile > 0 ? `+${tile.replace(".",",")}` : tile.replace(".",",") }%</td>
    </tr>
  );
};

export default CompareRow;
